import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React, { useState } from 'react';
import { Button, Col, Dropdown, Form } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import validCharacters from '../../../constants/valid-characters';
import { FactoryFilterInitialState } from '../../../core/initialState/filter-initial-state';
import { IFactoryFilter } from '../../../models/IFactoryFilter';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import { FilterValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import {
  ClearFilterIcon,
  CloseFilterIcon,
  FilterIcon,
} from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: any;
  id: number;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  onModalClosed: () => void;
  isLoading: boolean;
  isDisable: boolean;
  isFilterCleared: boolean;
  isFilterApplied: boolean;
  setIsFilterApplied: (status: boolean) => void;
}
const FilterComponent = (props: IProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggle = (isOpen: boolean, resetForm: () => void) => {
    if(!isOpen){
      resetForm();
    }
    setShowDropdown(isOpen);
  };

  return (
    <React.Fragment>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={FilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values: IFactoryFilter) => {
          props.submitHandler(values);
          setShowDropdown(false);
          props.setIsFilterApplied(true);
        }}
      >
        {({ dirty, resetForm, values }) => {
          return (
            <Dropdown
              className={`Filter-DID ${props.isDisable ? 'disabled-li' : ''}`}
              show={showDropdown}
              onToggle={(isOpen) => handleToggle(isOpen, resetForm)}
              // autoClose={false}
            >
              <Dropdown.Toggle
                className={`btn btn-light ${props.isFilterApplied ? 'btn-filter-disable' : 'btn-filter'}`}
                aria-expanded="false"
                title={formatMessage('filter')}
              >
                {/* <FilterIcon isDisable={props.isDisable} /> */}
                {!props.isFilterApplied ? (
                  <FilterIcon isDisable={props.isDisable} />
                ) : (
                  <ClearFilterIcon
                    onClick={(e) => {
                      // props.filterParmas(
                      //   { ...FactoryFilterInitialState },
                      //   true
                      // );
                      resetForm();
                      setShowDropdown(!showDropdown);
                      // props.setIsFilterApplied(!props.isFilterApplied);
                    }}
                  />
                )}
              </Dropdown.Toggle>
              <FormikForm className="user-form">
                {props.isLoading ? (
                  <FormLoader loading={props.isLoading} />
                ) : null}
                <Dropdown.Menu className="filter-menu">
                  <Dropdown.ItemText className="p-0">
                    <Form.Group controlId="dateRange">
                      <div
                        className={`filter-header border-bottom p-3 px-4 ${props.isFilterCleared ? '' : ''}`}
                      >
                        <h4>
                          {formatMessage('filter')}
                          <a
                            className="clear-filter float-end"
                            onClick={() => {
                              resetForm();
                              setShowDropdown(false);
                            }}
                          >
                            <CloseFilterIcon />
                          </a>
                        </h4>
                      </div>
                      <div className="p-3 px-4 row">
                        <Col md={6}>
                          <div className="form-group mb-0">
                            <Form.Group controlId="nameFilter">
                              <Field
                                data-testid="Name"
                                className="form-control"
                                name="FactoryName"
                                autoComplete="off"
                                type="text"
                                placeholder="factory_name"
                                as={FormikFormInput}
                                validcharacter={validCharacters}
                              />
                            </Form.Group>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="form-group mb-0">
                            <Form.Group controlId="skuFilter">
                              <Field
                                data-testid="Sku"
                                className="form-control"
                                name="City"
                                autoComplete="off"
                                type="text"
                                placeholder="factory_city"
                                as={FormikFormInput}
                                validcharacter={validCharacters}
                              />
                            </Form.Group>
                          </div>
                        </Col>

                        {/* <Col md={4}>
                          <div className="form-group mb-0">
                            <Form.Group controlId="skuFilter">
                              <Field
                                name="FactoryType"
                                as={FormikFormSelect}
                                options={FactoryTypeFilterOptions}
                                getData={false}
                                placeholder="factory_type"
                              />
                            </Form.Group>
                          </div>
                        </Col> */}
                      </div>
                    </Form.Group>
                  </Dropdown.ItemText>
                  <Dropdown.Divider className="mb-0" />
                  <div className="d-flex filter-btn p-3 px-4 justify-content-between align-items-center">
                    <Button
                      className="clear-filter "
                      onClick={() => {
                        props.filterParmas(FactoryFilterInitialState, true);
                        resetForm();
                        setShowDropdown(false);
                        props.setIsFilterApplied(false);
                      }}
                    >
                      {formatMessage('clear_all_filters')}
                    </Button>
                    <Button
                      variant="secondary"
                      type="submit"
                      className=""
                      disabled={!dirty || !values.FactoryName && !values.City}
                    >
                      {formatMessage('apply')}
                    </Button>
                  </div>
                </Dropdown.Menu>
              </FormikForm>
            </Dropdown>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default FilterComponent;
